import { Poly } from "../../Poly";
export class SceneRenderersRegister {
  constructor(scene) {
    this.scene = scene;
    this._renderersById = /* @__PURE__ */ new Map();
    this._registerTimeByRenderer = /* @__PURE__ */ new Map();
    this._resolves = [];
  }
  registerRenderer(renderer, options) {
    let assignId = true;
    if ((options == null ? void 0 : options.assignId) == false) {
      assignId = false;
    }
    if (assignId) {
      Poly.renderersController.assignIdToRenderer(renderer);
    }
    const id = Poly.renderersController.rendererId(renderer);
    if (id == null) {
      return;
    }
    this._renderersById.set(id, renderer);
    this._registerTimeByRenderer.set(renderer, performance.now());
    this._updateCache();
    if (this._renderersById.size == 1) {
      this._flushCallbacksWithRenderer(renderer);
    }
  }
  deregisterRenderer(renderer) {
    const id = Poly.renderersController.rendererId(renderer);
    if (id == null) {
      return;
    }
    this._renderersById.delete(id);
    renderer.dispose();
    this._updateCache();
  }
  lastRegisteredRenderer() {
    return this._lastRegisteredRenderer;
  }
  renderers() {
    const renderers = [];
    this._renderersById.forEach((renderer) => {
      renderers.push(renderer);
    });
    return renderers;
  }
  _updateCache() {
    this._lastRegisteredRenderer = void 0;
    this._registerTimeByRenderer.forEach((registerTime, renderer) => {
      if (this._lastRegisteredRenderer == void 0) {
        this._lastRegisteredRenderer = renderer;
      } else {
        const lastRegisterTime = this._registerTimeByRenderer.get(this._lastRegisteredRenderer);
        if (lastRegisterTime != null) {
          if (registerTime > lastRegisterTime) {
            this._lastRegisteredRenderer = renderer;
          }
        }
      }
    });
  }
  _flushCallbacksWithRenderer(renderer) {
    const callbacks = [];
    for (let r of this._resolves) {
      callbacks.push(r);
    }
    this._resolves = [];
    for (let c of callbacks) {
      c(renderer);
    }
  }
  async waitForRenderer() {
    if (this._lastRegisteredRenderer) {
      return this._lastRegisteredRenderer;
    } else {
      return new Promise((resolve, reject) => {
        this._resolves.push(resolve);
      });
    }
  }
}
